<template src="./template.html"></template>

<script>
import {queryCertificatesList, addCollection, cancelCollection, queryViewCertificateLink, checkReminderById, getAssociation} from "@/api/certificateList";
import { formattedDate } from "@/utils/formattedDate";

function getResult(condition) {
  const resultMapping = {
    'no': '型式试验证书',
    'type0': '型式试验报告',
    'type1': '主机',
    'type2': '控柜',
    'type3': '安全钳',
    'type4': '限速器',
    'type5': '缓冲器',
    'type6': '上超保护',
    'type7': '可编辑电路',
    'type8': '门锁',
    'type9': '其他补充证书',
    'note': '备注'
    // 添加更多的条件和对应的结果
  }
  // 检查条件并返回结果
  return resultMapping[condition] || 'Default result'
}

export default {
  data() {
    return {
      show: false,
      // 用户信息
      userList: '',
      // 是否显示个人信息弹窗
      dialogUser: false,
      // 文档搜索内容
      searchText: '',
      // 关键词
      categoryInfo: {
        categories: [],
        recommendCategories: [],
      },
      // 关键词搜索类型选项
      searchKeyWordTypeOptions: {
        type: [
          [0,1,2,3,9],
          [0,2,3,4,5,6,7,8,9]
        ],
        data: [
          { id: 0, name: '证书名称' },
          { id: 1, name: '发证机构' },
          { id: 2, name: '标签搜索' },
          { id: 3, name: '全文搜索' },
          { id: 4, name: '证书编号' },
          { id: 5, name: '下次核查形式' },
          { id: 6, name: '标准' },
          { id: 7, name: '型号规格' },
          { id: 8, name: '主要部件和新能指标' },
          { id: 9, name: '备注' },
        ]
      },
      // 形式配置选项
      formAppearanceArray: [
        { id: 0, name: '全部形式' },
        { id: 1, name: '牌匾' },
        { id: 2, name: '证书' },
        { id: 3, name: '公式名单' },
        { id: 4, name: '奖杯' },
        { id: 5, name: '奖牌' },
        { id: 6, name: '电子文件' },
        { id: 7, name: '电子版' },
        { id: 8, name: '证书+水晶' },
        { id: 9, name: '证书+牌匾' },
        { id: 10, name: '牌匾和批准通知' },
        { id: 11, name: '其他' },
      ],
      // 状态选项配置
      statusArray: [
        { id: null, name: '全部状态' },
        { id: 1, name: '生效中' },
        { id: 2, name: '即将失效' },
        { id: 3, name: '已更新' },
        { id: 0, name: '已失效' },
      ],
      // 证书类型
      certificateType: 1,
      // 备份数据
      initCertificateSift: [],
      // 筛选结果
      certificateSift: {
        // 关键词搜索
        keywordSearch: {
          id: 0,
          value: ''
        },
        // 获取时间
        time: '',
        // 形式
        formAppearance: 0,
        // 有效年限
        validTime: '',
        // 状态
        status: null
      },
      // 证书列表
      certifData: [],
      currentPage: 1, // 当前页码
      pageSize: 10,   // 每页显示的条数
      pageSizes: [10, 20, 50, 100],
      totalRows: 0,    // 总条数
      // 是否显示备注信息弹窗
      remarksDialogVisible: false,
      remarksValue: '',
      // 是否备注
      isRemarksValue: false,
      // 当前操作的证书id
      currentCertificateId: null,
      // 关联证书弹窗
      showAssociatedCertificateTableDialog: false,
      mainCertificateNo: null,
      relevanceCertificateData: [],
      filteringRelevanceCertificateData: [],
      // 关联证书表页码
      relevanceCertificateTablePageNumber: 1,
    }
  },
  filters: {
    filterDate(val) {
      /* 过滤时间 */
      if (!val) return '/'
      return formattedDate(val) || '/'
    }
  },
  mounted() {
    document.title = '我的收藏'
    this.getuser();
    this.getCertificatesList()
    // 备份书
    this.backupCertificateSift()
    // 禁止失效证书点击状态
    // this.$nextTick(() => {
    //   const disableRow = document.querySelectorAll('.disabled-row')
    //   disableRow.forEach(h => {
    //     h.addEventListener('click', function (event) {
    //       event.stopPropagation();
    //     });
    //   })
    // })
  },
  computed: {
    filterSearchKeyWordTypeOptions() {
      /* 过滤关键词下拉框选项 */
      const filterArray = this.searchKeyWordTypeOptions.data.filter(obj => this.searchKeyWordTypeOptions.type[this.certificateType-1].includes(obj.id))
      // console.log(filterArray)
      return filterArray
    },
    filterStatus() {
      /* 过滤状态 */
      // 1:生效中0:已失效,2：即将失效，3：已更新
      return (status) => {
        // 默认失效 0
        let statusObj = {
          str: '/',
          color: '#cccccc',
          flag: false
        }
        switch (status) {
          case 0:
            statusObj.str = '已失效'
            break
          case 1:
            statusObj.str = '生效中'
            statusObj.color = '#00B42A'
            statusObj.flag = true
            break
          case 2:
            statusObj.str = '即将失效'
            statusObj.color = '#D0202E'
            statusObj.flag = true
            break
          case 3:
            statusObj.str = '已更新'
            break
        }
        return statusObj
      }
    },
  },
  methods: {
    getuser() {
      /* 获取用户的信息 */
      this.$store
        .dispatch("user/getInfo")
        .then(res => {
          this.userList = res;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getOut() {
      /* 退出登录 */
      this.$request
        .getOut(this.userList.id)
        .then(res => {
          if (res.code === 200) {
            this.$message.success("退出登录成功");
            localStorage.removeItem("code");
            localStorage.removeItem("lxState");
            this.$router.push("/login");
            localStorage.removeItem("UserAdmin")();
            window.location.reload();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getUserManage() {
      /* 显示个人信息弹窗 */
      this.dialogUser = true;
    },
    handleKeyClick(key) {
      /* 关键词搜索 */
      // console.log(key);
      this.searchText = key;
      this.handleSearch();
    },
    handleSearch() {
    },
    backupCertificateSift() {
      /* 备份筛选结果的默认数据 */
      this.initCertificateSift = JSON.parse(JSON.stringify(this.certificateSift))
    },
    resetCertificateSift(type=null) {
      /* 清空操作 */
      // if (type) this.certificateType = 1
      this.certificateSift = JSON.parse(JSON.stringify(this.initCertificateSift))
      this.currentPage = 1
      this.getCertificatesList()
    },
    inquireCertificateList() {
      /* 查询收藏列表 */
      // console.log(this.certificateSift)
      this.currentPage = 1
      this.getCertificatesList()
    },
    async getCertificatesList() {
      /* 获取收藏列表 */

      // 处理获取时间
      let strDate = null
      let endDate = null
      if (this.certificateSift.time) {
        strDate = formattedDate(this.certificateSift.time[0])
        endDate = formattedDate(this.certificateSift.time[1])
      }

      // 处理有效年限
      let strDate2 = null
      let endDate2 = null
      if (this.certificateSift.validTime) {
        strDate2 = formattedDate(this.certificateSift.validTime[0])
        endDate2 = formattedDate(this.certificateSift.validTime[1])
      }

      // 处理形式
      let form = ''
      if (this.certificateSift.formAppearance) {
        const filterArray = this.formAppearanceArray.filter(obj => obj.id === this.certificateSift.formAppearance)
        form = filterArray[0].name
      }

      const res = await queryCertificatesList({
        from: 2,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        type2: this.certificateType,
        strDate,
        endDate,
        strDate2,
        endDate2,
        content: this.certificateSift.keywordSearch.value || null,
        type3: this.certificateSift.keywordSearch.id,
        form,
        stateFlag: this.certificateSift.status,
        source: this.certificateType === 1 ? 'category':'modelCategory'
      })
      if (res.code === 200) {
        this.certifData = res.data.records
        this.totalRows = res.data.total
      }
      console.log('收藏列表', res)
    },
    async handleAddCollection(id) {
      /* 收藏 */
      const res = await addCollection(
        id,
        this.remarksValue ? this.remarksValue : null
      )
      // 成功处理，更新备注
      if (res.code === 200) {
        this.certifData.map(certificate => {
          if(certificate.id === id) (certificate.notes = this.remarksValue)
        })
        this.$message('已备注')
      } else {
        this.$message.error('更新备注失败');
      }
      // 恢复默认
      this.isRemarksValue = false
      this.remarksValue = ''
      this.currentCertificateId = null
    },
    async handleCancelCollection(id) {
      /* 取消收藏 */
      const res = await cancelCollection(id)
      // if (res.code === 200) {
      //
      // } else {
      //
      // }
      // 成功处理，移除已取消收藏的证书
      this.certifData = this.certifData.filter(certificate => certificate.id !== id)
      this.$message('已取消收藏')
      // 恢复默认
      this.currentCertificateId = null
    },
    switchCertificate(i) {
      /* 切换证书列表 */
      this.certifData = []
      this.resetCertificateSift()
      this.getCertificatesList()
    },
    tableRowClassName({row}) {
      /*
        设置 Table 中的某一行处于某种状态
        disabled-row 失效
      */
      if( !this.filterStatus(row.stateFlag).flag ) {
        return 'disabled-row'
      }
      return '';
    },
    // 获取并跳转证书详情地址
    async getCertificateDetailLink(id) {
      const link = await queryViewCertificateLink(id)
      if (link.code === 200) window.open(link.msg, '_blank')
    },
    // 查看证书
    async viewCertificate(row) {
      // const check = await checkReminderById(row.id)
      // if(!(typeof check.data === 'boolean' && check.data === true)) {
      //   this.$confirm(check.msg, '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.getCertificateDetailLink(row.id)
      //   }).catch(() => {});
      // } else {
      //   this.getCertificateDetailLink(row.id)
      // }
      this.getCertificateDetailLink(row.id)
    },
    // 查询关系证书
    async queryAssociation(no) {
      const res = await getAssociation(no)
      // console.log('查询的关联证书', res)
      if (res.code === 200) {
        // 清空过滤列表数据
        this.filteringRelevanceCertificateData = []
        // 查询无绑定关系结果时
        if (JSON.stringify(res.data) === '{}' || res.data.length === 0) {
          this.filteringRelevanceCertificateData.push(this.filterAssociatedCertificate())
          return
        }
        this.relevanceCertificateData = res.data
        res.data.forEach(item => {
          this.filteringRelevanceCertificateData.push(this.filterAssociatedCertificate(item))
        })
        // console.log(this.filteringRelevanceCertificateData)
      }
    },
    // 过滤关联证书数据
    filterAssociatedCertificate(obj) {
      // console.log('obj', obj)
      const result = []
      result.push({
        name: getResult(`no`),
        type: 'no',
        data: obj.no ? [obj.no] : [this.mainCertificateNo]
      })
      for (let i = 0; i < Object.keys(obj).filter(key => key.startsWith('type')).length; i++) {
        result.push({
          name: getResult(`type${i}`),
          type: `type${i}`,
          data: obj ? JSON.parse(JSON.stringify(obj[`type${i}`])) : []
        })
      }
      // result.push({ name: getResult(`note`), type: 'note', data: obj.note || null })
      result.push({ name: getResult(`note`), type: 'note', data: obj.note ? [obj.note] : [] })
      // console.log('过滤的关联证书数据', result)
      return result
    },
    // 查看关联证书
    linkOthers(row, index) {
      // console.log(row)
      if (row.no === null) {
        this.$message.warning('该证书不存在编号！')
        return
      }
      this.showAssociatedCertificateTableDialog = true
      this.mainCertificateNo = row.no
      this.queryAssociation(row.no)
    },
    // 设置关联证书行样式
    setRelevanceContainerRowClassName({ rowIndex }) {
      const flag = this.relevanceCertificateData[this.relevanceCertificateTablePageNumber - 1].flag
      // console.log(flag)
      // flag -1开始（型式实验证书）
      if (flag + 1 === rowIndex || flag === undefined && rowIndex === 0) {
        return 'red-relevance-row'
      }
      return ''
    },
    // 根据编号打开证书
    jumpAssociatedNumberCertificate(number) {

    },
    // 关联证书当前页发生变化时
    currentAssociationListChange(val) {
      this.relevanceCertificateTablePageNumber = val
    },
    // 隐藏关联证书弹窗时
    hiddenAssociatedCertificateDialog() {
      this.filteringRelevanceCertificateData = []
      this.relevanceCertificateData = []
      this.relevanceCertificateTablePageNumber = 1
      this.mainCertificateNo = null
    },
    handleCollection(row) {
      /* 处理取消收藏 */
      this.$confirm('确定取消收藏嘛？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleCancelCollection(row.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
        // 恢复默认
        this.currentCertificateId = null
      });
    },
    handleSizeChange(size) {
      /* pageSize(每页条数) 改变时重新渲染列表 */
      this.pageSize = size
      // 重新请求数据
      this.currentPage = 1
      this.getCertificatesList()
    },
    handleCurrentChange(num) {
      /* currentPage 改变时根据页码获取对应列表 */
      this.getCertificatesList()
      // 回到列表顶部
      // this.$refs.certifListRef.$el.scrollTo(0, 0);
    },
    modifyRemarks(row) {
      /* 触发备注 */
      // console.log(row)
      this.currentCertificateId = row.id
      if(row.notes) {
        this.remarksValue = decodeURIComponent(row.notes)
      }
      // 显示弹窗
      this.remarksDialogVisible = true
    },
    closeRemarksDialog() {
      /* 备注弹窗消失时 */
      // 判断是否需要增/改备注
      if(this.isRemarksValue) {
        // 处理备注
        this.handleAddCollection(this.currentCertificateId)
      } else {
        this.$message({
          type: 'info',
          message: '已取消'
        });
        // 恢复默认
        this.remarksValue = ''
        this.currentCertificateId = null
      }
    },
  }
}
</script>

<style lang="less" src="./style.less" scoped></style>
